import axios from 'axios';

axios.defaults.withCredentials = false;
axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.baseURL = '/api';

const base = '/api';

export default {
  getApiHref: apiMethod => `${base}/${apiMethod}`,

  sysInfo: {
    getValue: () => axios.get(`${base}/sysInfo/value`).then(res => res.data),
    getAllModules: () => axios.get(`${base}/sysInfo/GetAllModules`).then(res => res.data)
  },

  users: {
    login: params => axios.post(`${base}/Account/Login`, params).then(res => res.data),
    loginDD: params => axios.post(`${base}/Account/LoginDD`, params).then(res => res.data),
    logout: token => axios.post(`${base}/Account/Logout/${token}`).then(res => res.data),
    checkToken: token => axios.get(`${base}/Account/checkToken/${token}`).then(res => res.data),
    list: () => axios.get(`${base}/Account/list`).then(res => res.data),
    save: (id, params) => axios.post(`${base}/Account/Save/${id}`, params).then(res => res.data),
    saveNew: params => axios.post(`${base}/Account/SaveNew`, params).then(res => res.data),
    savePsw: (id, params) => axios.post(`${base}/Account/SavePsw/${id}`, params).then(res => res.data),
    resetPsw: (id) => axios.post(`${base}/Account/ResetPsw/${id}`).then(res => res.data),
    delete: (id) => axios.post(`${base}/Account/Delete/${id}`).then(res => res.data),
    invalid: (id) => axios.post(`${base}/Account/Invalid/${id}`).then(res => res.data),
    valid: (id) => axios.post(`${base}/Account/Valid/${id}`).then(res => res.data)
  },

  tenant: {
    getState: (id) => axios.get(`${base}/Tenant/GetState/${id}`).then(res => res.data),
    enable: (id) => axios.post(`${base}/Tenant/Enable/${id}`).then(res => res.data),
    disable: (id) => axios.post(`${base}/Tenant/Disable/${id}`).then(res => res.data)
  },

  project: {
    getPage: (pageNo, params) => axios.post(`${base}/Project/GetPage/${pageNo}`, params).then(res => res.data),
    find: projectId => axios.get(`${base}/Project/Find/${projectId}`).then(res => res.data),
    append: data => axios.post(`${base}/Project/Append`, data).then(res => res.data),
    save: (projectId, data) => axios.post(`${base}/Project/Save/${projectId}`, data).then(res => res.data),
    delete: projectId => axios.post(`${base}/Project/Delete/${projectId}`).then(res => res.data),
    submit: params => axios.post(`${base}/Project/Submit`, params).then(res => res.data)
  }
};



// WEBPACK FOOTER //
// ./src/api/api.js